export enum ImageAlias {
  REAL = "real",
  REAL_ANONYMIZED = "real_anonymized",
  REAL_INVERTED = "real_inverted",
  HD = "hd",
  HD_ANONYMIZED = "hd_anonymized",
  HD_ANONYMIZED_CROP = "hd_anonymized_crop",
  HD_INVERTED = "hd_inverted",
  HD_SHARPENED = "hd_sharpened",
  HD_SHARPENED_INVERTED = "hd_sharpened_inverted",
  QHD = "qhd",
  QHD_ANONYMIZED = "qhd_anonymized",
  QHD_INVERTED = "qhd_inverted",
  QHD_SHARPENED = "qhd_sharpened",
  QHD_SHARPENED_INVERTED = "qhd_sharpened_inverted",
  REGULAR = "regular",
  REGULAR_ANONYMIZED = "regular_anonymized",
  REGULAR_INVERTED = "regular_inverted",
  REGULAR_SHARPENED = "regular_sharpened",
  REGULAR_SHARPENED_INVERTED = "regular_sharpened_inverted",
  GALLERY = "gallery",
  GALLERY_INVERTED = "gallery_inverted",
  COLLECTION = "collection",
  THUMB = "thumb",
  HISTOGRAM = "histogram",
  IOTD = "iotd",
  IOTD_MOBILE = "iotd_mobile",
  IOTD_CANDIDATE = "iotd_candidate",
  STORY = "story",
  STORY_CROP = "story_crop",
  DUCKDUCKGO = "duckduckgo",
  DUCKDUCKGO_SMALL = "duckduckgo_small",
  INSTAGRAM_STORY = "instagram_story"
}

export class ImageAliasSize {
  public static readonly STORY = { width: 460, height: 320 };
}
